/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonRelayInfo,
    JsonRelayInfoFromJSON,
    JsonRelayInfoFromJSONTyped,
    JsonRelayInfoToJSON,
} from './JsonRelayInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonRelayInfo
 */
export interface ApiResultOfListOfJsonRelayInfo {
    /**
     * 
     * @type {Array<JsonRelayInfo>}
     * @memberof ApiResultOfListOfJsonRelayInfo
     */
    data?: Array<JsonRelayInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonRelayInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonRelayInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonRelayInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonRelayInfo
     */
    result?: ApiResultOfListOfJsonRelayInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonRelayInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonRelayInfoFromJSON(json: any): ApiResultOfListOfJsonRelayInfo {
    return ApiResultOfListOfJsonRelayInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonRelayInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonRelayInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonRelayInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonRelayInfoToJSON(value?: ApiResultOfListOfJsonRelayInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonRelayInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

